import { get, put } from 'common/api';

export const getAccount = id => get(`/v5/accounts/${id}`);
export const getAccounts = () =>
  get(`/v5/users/me/accounts?sort=subdomain&per_page=500&page=1`);
export const updateAccount = formData => put(`/v5/accounts/current`, formData);
export const putAccount = (id, account, config) =>
  put(`/v5/accounts/current`, { account }, config);
